import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

console.info('[boot]', { ts: Date.now() });

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
